import { CheckCircleFilled, CloseCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import { ModalProps } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import React, { ReactNode } from 'react';
import { useIsMobileL } from '../../hooks/useBreakpoints';
import { MobileModal } from './MobileModal';
import { FooterButton } from './styles';

export enum EvidiaStaticModalType {
	INFO = 'info',
	SUCCESS = 'success',
	WARNING = 'warning',
	ERROR = 'error',
}

const ICONS = {
	[EvidiaStaticModalType.INFO]: <ExclamationCircleFilled style={{ color: '#1677ff' }} />,
	[EvidiaStaticModalType.SUCCESS]: <CheckCircleFilled style={{ color: '#52c41a' }} />,
	[EvidiaStaticModalType.WARNING]: <ExclamationCircleFilled color="#faad14" style={{ color: '#faad14' }} />,
	[EvidiaStaticModalType.ERROR]: <CloseCircleFilled style={{ color: '#ff4d4f' }} />,
};

const getStaticModalHeader = (staticType: EvidiaStaticModalType, title?: ReactNode) => {
	if (!title) {
		return null;
	}

	return (
		<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
			{ICONS[staticType]}
			<span>{title}</span>
		</div>
	);
};

export type EvidiaModalProps = ModalProps & {
	staticType?: EvidiaStaticModalType;
	onlyCloseButton?: boolean;
	disableClickOutsideClose?: boolean;
	onCancel?: (e?: React.MouseEvent) => void;
};

export const EvidiaModal = ({ open, ...rest }: EvidiaModalProps) => {
	const isMobile = useIsMobileL();

	if (!open) {
		return null;
	}

	let props = { ...rest };

	if (rest.staticType) {
		props = {
			...rest,
			title: getStaticModalHeader(rest.staticType, rest.title),
		};
	}

	if (rest.onlyCloseButton) {
		props = {
			...rest,
			footer: (
				<FooterButton type="primary" onClick={rest.onCancel}>
					Zavřít
				</FooterButton>
			),
		};
	}

	if (isMobile) {
		return <MobileModal open={open} {...props} />;
	}

	return <Modal open={open} {...props} zIndex={props.zIndex ?? 2147483647} />;
};
